import PillarHeader from './PillarHeader'

export default PillarHeader